// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceModelId } from './DeviceModel';
import { z } from 'zod';
export const deviceModelConfigParamId = (z.number());
export const deviceModelConfigParam = z.object({
    id: deviceModelConfigParamId,
    device_model_id: deviceModelId,
    key: z.string(),
    type: z.string(),
    label: z.string(),
    unit: z.string().nullable(),
    description: z.string().nullable(),
    group_label: z.string().nullable(),
    min_value: z.number().nullable(),
    max_value: z.number().nullable(),
    default_value: z.unknown().nullable(),
    enum_values: z.unknown().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const deviceModelConfigParamInitializer = z.object({
    id: deviceModelConfigParamId.optional(),
    device_model_id: deviceModelId,
    key: z.string(),
    type: z.string(),
    label: z.string(),
    unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    group_label: z.string().optional().nullable(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.unknown().optional().nullable(),
    enum_values: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const deviceModelConfigParamMutator = z.object({
    id: deviceModelConfigParamId.optional(),
    device_model_id: deviceModelId.optional(),
    key: z.string().optional(),
    type: z.string().optional(),
    label: z.string().optional(),
    unit: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    group_label: z.string().optional().nullable(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.unknown().optional().nullable(),
    enum_values: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=DeviceModelConfigParam.js.map